import DictTrackerObjPtrGen from "../../prop-tracker-utils/dict-tracker-obj-ptr-gen.js";
import PropChainTracker from "../../prop-tracker-utils/prop-chain-tracker.js";

import MorphTargetFilter from "./trackers/objects/animations/morph-target-filter.js";

class MorphTargetWeights {
    constructor(wrapCtx, evtCtx) {
        this._animValueTracker = new PropChainTracker(evtCtx);
        const filter = new MorphTargetFilter(this._animValueTracker, evtCtx);
        this._weightGen = new DictTrackerObjPtrGen(wrapCtx, evtCtx, filter);
    }

    get weights() { return this._weightGen.pointer; }

    track(animValues) {
        if (animValues) {
            this._animValueTracker.track(animValues.data, ["value"]);
            this._weightGen.start();
        } else {
            this._animValueTracker.track();
            this._weightGen.stop();
        }
    }

    update() {
        this._weightGen.update();
    }
}

export default MorphTargetWeights;
